<template>
  <div class="com-container relative">
    <div class="main-box">
      <div class="relative">
        <div class="top-title">{{ kechengInfo.cat_name }}</div>
        <div class="swiper-box">
          <div class="search-box">
            <div class="item">
              <el-select
                v-model="OneCategoryVal"
                placeholder="请选择"
                class="myselect"
              >
                <el-option
                  v-for="item in OneCategory"
                  :key="item.id"
                  :label="item.cat_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <el-select
                v-show="TwoCategoryShow"
                v-model="TwoCategoryVal"
                placeholder="请选择"
                class="myselect"
              >
                <el-option
                  v-for="item in TwoCategory"
                  :key="item.id"
                  :label="item.cat_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <el-select
                v-show="ThreeCategoryShow"
                v-model="ThreeCategoryVal"
                placeholder="请选择"
                class="myselect"
              >
                <el-option
                  v-for="item in ThreeCategory"
                  :key="item.id"
                  :label="item.cat_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="recommendPage swiper-no-swiping" v-if="isRouterAlive">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in listData" :key="index">
                <div class="s-item">
                  <div
                    class="course-box"
                    v-for="(item2, index2) in item"
                    :key="index2"
                  >
                    <!-- 正式的不加锁 -->
                    <div
                      @click="showCourse(index, index2)"
                      class="pointer"
                      v-if="kecheng_type == '正式'"
                    >
                      <img
                        src="../assets/images/list/course1.png"
                        alt
                        class="c-img"
                      />
                      <div class="c-title">{{ item2.title }}</div>
                    </div>
                    <!-- 试用的区分课程状态 -->
                    <div
                      @click="showCourse(index, index2)"
                      class="pointer"
                      v-else-if="item2.shiyong_status == 1"
                    >
                      <img
                        src="../assets/images/list/course1.png"
                        alt
                        class="c-img"
                      />
                      <div class="c-title">{{ item2.title }}</div>
                    </div>
                    <div v-else>
                      <img
                        src="../assets/images/list/course1.png"
                        alt
                        class="c-img"
                      />
                      <div class="c-title title-opacity">{{ item2.title }}</div>
                      <img
                        src="../assets/images/list/course2.png"
                        alt
                        class="c-img2"
                      />
                    </div>
                  </div>
                  <div
                    class="bt_classify_name_empty"
                    style="visibility: hidden"
                  ></div>
                  <div
                    class="bt_classify_name_empty"
                    style="visibility: hidden"
                  ></div>
                  <div
                    class="bt_classify_name_empty"
                    style="visibility: hidden"
                  ></div>
                  <div
                    class="bt_classify_name_empty"
                    style="visibility: hidden"
                  ></div>
                  <div
                    class="bt_classify_name_empty"
                    style="visibility: hidden"
                  ></div>
                  <div
                    class="bt_classify_name_empty"
                    style="visibility: hidden"
                  ></div>
                </div>
              </swiper-slide>

              <div
                class="swiper-pagination"
                slot="pagination"
                style="bottom: 5%"
              ></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>

          <div class="clear"></div>
        </div>
      </div>
      <!-- relavive end -->
    </div>
    <!-- main-box end -->
    <!-- 底部 -->
    <Footer></Footer>

    <!-- 右侧弹窗 -->
    <div id="right" :style="right_px" v-show="right_box_show">
      <div class="r-left" @click="rightShow()">
        <el-image :src="right_img" alt class="f-btn" width="100%"></el-image>
      </div>
      <div class="r-right">
        <div class="r-item" @click="closeCouseDialog()">返回</div>
        <div class="r-item" @click="showMetronome()">节拍器</div>
        <div class="r-item">批注</div>
        <div class="r-item">白板</div>
        <div class="r-item" @click="closeExe()">关闭</div>
      </div>
    </div>

    <!-- 课程内容 -->
    <el-dialog
      :title="courseInfo.title"
      :visible.sync="dialogVisible_course"
      :fullscreen="true"
      :show-close="false"
      custom-class="dialog-course"
    >
      <div class="com-info-box relative" @click="rightShow()">
        <!-- <div class="btn-close" @click="closeCouseDialog()">
          <img src="../assets/images/other/btn_close.png" alt width="100%" />
        </div>-->
        <!-- 底部 -->
        <Progress
          :ProgressgVisible="ProgressgVisible"
          @toParent="getChildMsg"
          v-if="update"
          ref="notice_add"
        ></Progress>
        <div class="cov-video-container" v-if="courseInfo.filename">
          <object
            width="100%"
            classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
            codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=9,0,28,0"
            id="abcdef"
            v-show="videoShow"
            style="height: 0px; float: left"
          >
            <param value="high" name="quality" />
            <param value="transparent" name="wmode" />
            <embed
              :height="height"
              width="100%"
              name="abcdef"
              wmode="transparent"
              type="application/x-shockwave-flash"
              pluginspage="http://www.adobe.com/shockwave/download/download.cgi?P1_Prod_Version=ShockwaveFlash"
              quality="high"
              :src="courseInfo.filename"
            />
          </object>
        </div>
        <p class="info" v-else>暂未上传课程</p>
      </div>
    </el-dialog>

    <div v-show="box_show" id="moveDiv" :visible.sync="dialogVisible_course" class="jsq"
    @mousedown="draggableFun($event)"
    @touchstart="down()"
    @touchmove.prevent.stop="move()"
    @touchend="end()"
    :style="{top:position.y+'px', left:position.x+'px'}"
    >
      <div class="com-info-box relative">
        <!-- 底部 -->
        <div class="cov-video-container">
          <object
            width="100%"
            classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
            codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=9,0,28,0"
            id="abcdef"
            style="height: 0px; float: left"
          >
            <param value="high" name="quality" />
            <param value="transparent" name="wmode" />
            <embed
              height="600px"
              width="100%"
              name="abcdef"
              wmode="transparent"
              type="application/x-shockwave-flash"
              pluginspage="http://www.adobe.com/shockwave/download/download.cgi?P1_Prod_Version=ShockwaveFlash"
              quality="high"
              src="https://yizhibao-app.oss-cn-beijing.aliyuncs.com/video/%E8%8A%82%E6%8B%8D%E5%99%A8.swf"
            />
          </object>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

/* eslint-disable */
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Footer from "@/components/Footer.vue";
import Progress from "@/components/Progress.vue";

var dx,dy;
var screenWidth = window.screen.width;
var screenHeight = window.screen.height

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    Footer,
    Progress,
  },
  data() {
    return {
      isRouterAlive: true, //一开始router-view为true
      flags: false,
      position: { x: 0, y: 0 },
      nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
      update: true,
      height: document.documentElement.clientHeight,
      ProgressgVisible: false,
      kecheng_type: this.$route.params.kecheng_type,
      listData: [],
      map: [],
      dialogVisible_course: false,
      videoShow: false,
      right_px: "right:-130px",
      right_show: 0,
      right_box_show: false,
      right_img: require("../assets/images/right/left.png"),
      swiperOption: {
        loop: false, //循环
        // autoplay: {
        //   delay: 5000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },

        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          //分页
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            //自定义分页的按钮
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          },
        },
      },
      kechengInfo: "",
      courseInfo: "",
      kecheng_category_id: this.$route.params.kecheng_category_id,
      OneCategory: "",
      OneCategoryVal: "",

      TwoCategoryShow: false,
      TwoCategory: "",
      TwoCategoryVal: "",

      ThreeCategoryShow: false,
      ThreeCategory: "",
      ThreeCategoryVal: "",

      box_show: false,

      machine_status: "",
      machine_num: "",
    };
  },
  mounted() {
    this.$axios({
      method: "GET",
      url: this.apiTp5Url + "/getUuid",
      params: {
        username: localStorage.getItem("username"),
        password: localStorage.getItem("password"),
      },
    })
      .then((response) => {
        this.machine_status = response.data.machine_num;
        this.machine_num = response.data.data;
      })
      .catch((err) => {
        console.log(err);
      });

    // 登录判定
    var that = this;
    if (this.getCookie("account_id")) {
      this.setCookie("account_id", this.getCookie("account_id"), 120);
    } else {
      this.$message({
        message: "请先登录",
        type: "warning",
        duration: 1000,
        onClose: function () {
          that.$router.push({ path: "/login" });
        },
      });
    }
    this.$axios({
      method: "GET",
      url: this.apiTp5Url + "/getCourseList",
      params: {
        kecheng_category_id: this.$route.params.kecheng_category_id,
        kecheng_type: this.$route.params.kecheng_type,
      },
    })
      .then((response) => {
        console.log(response.data,"数据");
        //console.log("返回:" + JSON.stringify(response.data.listData[0]));
        //this.listData = response.data.listData.slice(0, 12);
        this.OneCategory = response.data.listTopCategory;
        this.OneCategoryVal = response.data.listTopCategory[0]["id"];
        this.kechengInfo = response.data.kechengInfo;
        if (response.data.listTwoCategory.length > 0) {
          this.TwoCategoryShow = true;
          this.TwoCategory = response.data.listTwoCategory;
          this.TwoCategoryVal = response.data.listTwoCategory[0]["id"];
        }
        if (response.data.listThreeCategory.length > 0) {
          this.ThreeCategoryShow = true;
          this.ThreeCategory = response.data.listThreeCategory;
          this.ThreeCategoryVal = response.data.listThreeCategory[0]["id"];
        }

        var chunk = 21;
        var len = response.data.listData.length;

        var result = [];
        for (let i = 0; i < len; i += chunk) {
          result.push(response.data.listData.slice(i, i + chunk)); // 每10项分成一组
        }

        this.listData = result;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    draggableFun(val){
      var one = document.getElementById("moveDiv");
      var dragFlag = false;
      var disX = 0;
      var disY = 0;

      one.onmousedown = function (ev) {
        if (!dragFlag) {
          dragFlag = true;
        }
        var oEvent = ev||event;
        //处理兼容性和滚动条
        disX =  oEvent.clientX - one.offsetLeft;
        disY =  oEvent.clientY - one.offsetTop;
        document.onmousemove = function (ev){
            console.log("29")
            var oEvent = ev||event;
            var l = oEvent.clientX - disX;
            var t = oEvent.clientY - disY;
            //此处的判断是为了防止拖拽框被拖出屏幕可视区域
            if(l<0) {
                l=0;
            }else if(l>document.documentElement.clientWidth - one.offsetWidth){
                l = document.documentElement.clientWidth - one.offsetWidth;
            }
            if(t<0) {
                t=0;
            }else if(t>document.documentElement.clientHeight- one.offsetHeight){
                t = document.documentElement.clientHeight - one.offsetHeight;
            }
            one.style.left = l+ 'px';
            one.style.top  = t+ 'px';
        };

        document.onmouseup = function (){
            console.log("49")
            document.onmousemove = null;
            document.onmouseup = null;
        }
      };
    },

    down(){
      this.flags = true;
      let touch;
      if(event.touches){
          touch = event.touches[0];
      }else {
          touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = moveDiv.offsetLeft;
      this.dy = moveDiv.offsetTop;
    },
    move(){
      if(this.flags){
        let touch ;
        if(event.touches){
            touch = event.touches[0];
        }else {
            touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx+this.nx;
        this.yPum = this.dy+this.ny;
        //添加限制：只允许在屏幕内拖动
      const maxWidth = document.body.clientWidth - 54;//屏幕宽度减去悬浮框宽高
      const maxHeight = document.body.clientHeight - 54;
      if (this.xPum < 0) { //屏幕x限制
      this.xPum = 0;
      } else if (this.xPum>maxWidth) {
        this.xPum = maxWidth;
      }
      if (this.yPum < 0) { //屏幕y限制
      this.yPum = 0;
      } else if (this.yPum>maxHeight) {
      this.yPum = maxHeight;
      }
        moveDiv.style.left = this.xPum+"px";
        moveDiv.style.top = this.yPum +"px";
        //阻止页面的滑动默认事件
        document.addEventListener("touchmove",function(){ // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
            event.preventDefault();//jq 阻止冒泡事件
            // event.stopPropagation(); // 如果没有引入jq 就用 stopPropagation()
        },false);
      }
    },
  //鼠标释放时候的函数
    end(){
      this.flags = false;
    },


    goback() {
      this.$router.go(-1);
    },
    // 显示右侧按钮
    rightShow() {
      if (this.right_show == 1) {
        this.$set(this, "right_px", "right:-130px;transition: all .3s ease;");
        this.$set(this, "right_show", 0);
        this.$set(
          this,
          "right_img",
          require("../assets/images/right/left.png")
        );
      } else {
        this.$set(this, "right_px", "right:0px;transition: all .3s ease;");
        this.$set(this, "right_show", 1);
        this.$set(
          this,
          "right_img",
          require("../assets/images/right/right.png")
        );
      }
    },
    // 获取课程通用按钮
    getNewCourseList() {
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getCourseList",
        params: {
          kecheng_category_id: this.kecheng_category_id,
          category_one_id: this.OneCategoryVal,
          category_two_id: this.TwoCategoryVal,
          category_Three_id: this.ThreeCategoryVal,
          kecheng_type: this.$route.params.kecheng_type,
        },
      })
        .then((response) => {
          //console.log("返回:" + JSON.stringify(response.data));
          console.log(
            "获取课程列表返回map:" + JSON.stringify(response.data.map)
          );
          var chunk = 21;
          var len = response.data.listData.length;

          var result = [];
          for (let i = 0; i < len; i += chunk) {
            result.push(response.data.listData.slice(i, i + chunk)); // 每10项分成一组
          }

          this.listData = result;
          console.log(this.listData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 关闭弹窗
    closeCouseDialog() {
      this.right_show = 0;
      this.right_box_show = false;
      this.box_show = false;
      this.$set(this, "dialogVisible_course", false);
      this.$set(this, "ProgressgVisible", false);
      this.$set(this, "videoShow", false);
      this.rightShow();
      //this.$router.go(0);
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getUuid",
        params: {
          username: localStorage.getItem("username"),
          password: localStorage.getItem("password"),
        },
      })
        .then((response) => {
          this.machine_status = response.data.machine_num;
          this.machine_num = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 节拍器
    showMetronome() {
      if (this.box_show === true) {
        this.box_show = false;
      } else {
        this.box_show = true;
      }
    },
    //显示课程弹窗
    showCourse(index, index2) {
      //console.log(this.machine_num,"dasdsa1");
      //console.log(localStorage.getItem("deviceNum"),"dasdsa2");

      if (this.machine_status === "多设备") {
        if (localStorage.getItem("deviceNum") == this.machine_num) {
          var localArr = [];
          this.right_show = 1;
          this.right_box_show = true;
          this.rightShow();
          this.dialogVisible_course = true;
          this.courseInfo = this.listData[index][index2];

          var that = this;
          // that.videoShow = true; //进度条修复后隐藏此项
          //进度条组件故障，暂时关闭
          var temp = [];
          if (this.courseInfo.filename) {
            if (localStorage.getItem("arr")) {
              if (localStorage.getItem("arr").indexOf(",") == -1) {
                temp.push(localStorage.getItem("arr"));
              } else {
                temp = localStorage.getItem("arr").split(",");
              }
            } else {
              temp.push(this.courseInfo.id);
              localStorage.setItem("arr", temp);
            }

            //如果有视频，使用进度条
            this.$set(this, "ProgressgVisible", false);
            // 移除组件
            that.$set(that, "update", false);

            console.log(temp.indexOf(String(that.courseInfo.id)), "dasdasd");

            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            that.$nextTick(() => {
              if (temp.indexOf(String(that.courseInfo.id)) == -1) {
                that.update = true;
              } else {
                that.update = false;
              }
            });

            setTimeout(funcName, 3000); //2秒后加载
            setTimeout(funcName2, 0); //2秒后加载

            function funcName() {
              that.$set(that, "ProgressgVisible", false);
            }
            function funcName2() {
              that.videoShow = true;
            }
          } else {
            that.$set(that, "ProgressgVisible", false);
          }

          if (localStorage.getItem("arr")) {
            if (localStorage.getItem("arr").indexOf(",") == -1) {
              localArr.push(localStorage.getItem("arr"));
            } else {
              localArr = localStorage.getItem("arr").split(",");
            }
            if (localArr.indexOf(String(this.courseInfo.id)) == -1) {
              localArr.push(String(this.courseInfo.id));
            }
          } else {
            localArr.push(this.courseInfo.id);
            localStorage.setItem("arr", localArr);
          }

          localStorage.setItem("arr", localArr);
        } else {
          this.$confirm(
            "您的账号已在其它设备登录，请返回重新登录继续使用",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              //点击确定的操作(调用接口)
              nw.Window.get().close();
              localStorage.removeItem("arr");
              localStorage.removeItem("page");
            })
            .catch(() => {
              //几点取消的提示
            });
        }
      } else {
        var localArr = [];
        this.right_show = 1;
        this.right_box_show = true;
        this.rightShow();
        this.dialogVisible_course = true;
        this.courseInfo = this.listData[index][index2];

        var that = this;
        // that.videoShow = true; //进度条修复后隐藏此项
        //进度条组件故障，暂时关闭
        var temp = [];
        if (this.courseInfo.filename) {
          if (localStorage.getItem("arr")) {
            if (localStorage.getItem("arr").indexOf(",") == -1) {
              temp.push(localStorage.getItem("arr"));
            } else {
              temp = localStorage.getItem("arr").split(",");
            }
          } else {
            temp.push(this.courseInfo.id);
            localStorage.setItem("arr", temp);
          }

          //如果有视频，使用进度条
          this.$set(this, "ProgressgVisible", false);
          // 移除组件
          that.$set(that, "update", false);

          console.log(temp.indexOf(String(that.courseInfo.id)), "dasdasd");

          // 在组件移除后，重新渲染组件
          // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
          that.$nextTick(() => {
            if (temp.indexOf(String(that.courseInfo.id)) == -1) {
              that.update = true;
            } else {
              that.update = false;
            }
          });

          setTimeout(funcName, 3000); //2秒后加载
          setTimeout(funcName2, 0); //2秒后加载

          function funcName() {
            that.$set(that, "ProgressgVisible", false);
          }
          function funcName2() {
            that.videoShow = true;
          }
        } else {
          that.$set(that, "ProgressgVisible", false);
        }

        if (localStorage.getItem("arr")) {
          if (localStorage.getItem("arr").indexOf(",") == -1) {
            localArr.push(localStorage.getItem("arr"));
          } else {
            localArr = localStorage.getItem("arr").split(",");
          }
          if (localArr.indexOf(String(this.courseInfo.id)) == -1) {
            localArr.push(String(this.courseInfo.id));
          }
        } else {
          localArr.push(this.courseInfo.id);
          localStorage.setItem("arr", localArr);
        }

        localStorage.setItem("arr", localArr);
      }
    },
    getChildMsg(dialogVisible_course) {},

    closeExe() {
      this.$confirm("是否要关闭课件平台？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //点击确定的操作(调用接口)
          nw.Window.get().close();
          localStorage.removeItem("arr");
          localStorage.removeItem("page");
        })
        .catch(() => {
          //几点取消的提示
        });
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  watch: {
    OneCategoryVal: function (nval, oval) {
      console.log(nval + "-" + oval);
      console.log(this.OneCategoryVal);
      if (oval) {
        var _this = this;
        this.$axios({
          method: "GET",
          url: this.apiTp5Url + "/getSonCorseCategoryList",
          params: {
            parent_id: nval,
          },
        })
          .then((response) => {
            console.log(
              "选择一级返回数据:" + JSON.stringify(response.data.listData)
            );
            _this.TwoCategoryVal = null;
            if (response.data.count > 0) {
              this.OneCategoryVal = nval;
              this.TwoCategoryShow = true;
              this.TwoCategory = response.data.listData;
            
            } else {
              this.TwoCategoryShow = false;
              this.TwoCategory = "";
            }
              this.getNewCourseList();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    TwoCategoryVal: function (nval, oval) {
      //判断当前分类是否有课程，无课程不会返回

      var _this = this;
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getSonCorseCategoryList",
        params: {
          parent_id: nval,
        },
      })
        .then((response) => {
          console.log("选择二级返回数据:" + JSON.stringify(response.data));
          _this.ThreeCategoryVal = null;
          this.getNewCourseList();
          if (response.data.count > 0) {
            this.TwoCategoryVal = nval;
            this.ThreeCategoryShow = true;
            this.ThreeCategory = response.data.listData;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
* {
  outline: none;
  touch-action: pan-y;
  touch-action: none;
}
.main-box {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.com-container {
  max-width: 1920px;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/images/list/bg.jpg") no-repeat center top;
  background-size: 100% 100%;
}
.top-title {
  text-align: center;
  padding: 10px;
  font-family: newfont;
  font-size: 80px;
  line-height: 100px;
  color: #fff;
  text-shadow: 0.2rem 0rem 0.5rem #201e89, -0.2rem 0rem 0.5rem #201e89,
    0rem 0.2rem 0.5rem #201e89, 0rem -0.2rem 0.5rem #201e89;
}
/* 搜索框 */
.search-box {
  height: 60px;
  margin-bottom: 10px;
}
.search-box .item {
  width: auto;
  max-width: 218px;
  float: left;
  margin-right: 20px;
}
.search-box .item img {
  width: 100%;
}
/* 轮播图 */
.swiper-box {
  margin: 2% 10%;
}
.recommendPage {
  position: relative;
  width: 100%;
  height: 680px;
}
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../assets/images/list/bk.png") no-repeat center top;
  background-size: 100% 100%;
}

.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  color: #000;
  font-size: 16px;
  text-align: center;
}
.recommendPage .swiper-container .swiper-slide .s-item {
  text-align: center;
  width: 90%;
  margin: 3.5% auto;
  height: 80%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.s-item .course-box {
  width: 13%;
  /*  float: left;
  text-align: center;
  margin-left: 80px;
  margin-top: 30px;*/
  position: relative;
  height: 33%;
}
.s-item .bt_classify_name_empty {
  width: 13%;
  /*  float: left;
  text-align: center;
  margin-left: 80px;
  margin-top: 30px;*/
  position: relative;
}
.s-item .course-box .c-img {
  width: 90%;
}
.s-item .course-box .c-img2 {
  width: 90%;
  position: absolute;
  left: 5%;
  opacity: 0.6;
  z-index: 10;
}
.s-item .course-box .c-title {
  font-size: 24px;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 60%;
  line-height: 30px;
  color: #534294;
  letter-spacing: 2px;
  font-weight: 600;
}

.s-item .course-box .title-opacity {
  opacity: 1;
}

.s-item .course-box .c-title-burrent {
  background: rgba(0, 0, 0, 0.6);
  width: 70%;
  margin-left: 15%;
  border-radius: 10px;
  color: #fff;
  opacity: 0.5;
}
.s-item .course-box:hover .c-title {
  color: #0080ff;
}
/* 左右箭头 */
.swiper-button-prev {
  left: 32%;
  top: 92%;
  background: url("../assets/images/index/left.png") no-repeat center top;
  background-size: 40px;
  width: 60px;
  height: 60px;
  outline: none;
}

.swiper-button-next {
  right: 32%;
  top: 92%;
  background: url("../assets/images/index/right.png") no-repeat center top;
  background-size: 40px;
  width: 60px;
  height: 60px;
  outline: none;
}

/* 右侧弹窗 */
#right {
  position: fixed;
  top: 20%;
  background: url("../assets/images/right/bg.png") no-repeat center top;
  background-size: 100%;
  height: 600px;
  width: 180px;
  z-index: 99999;
  padding-top: 20px;
}
#right .r-left {
  width: 30px;
  float: left;
  padding-top: 145px;
  margin-left: 20px;
}
#right .r-right {
  float: right;
  width: 95px;
  margin: -5px 0 0 0;
}
#right .r-right .r-item {
  background: #fff;
  color: #2eb8be;
  clear: both;
  border-radius: 6px;
  margin-top: 25px;
  width: 80px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
}

.jsq {
  position: fixed;
  margin: auto;
  z-index: 3000;
  width: 400px;
  height: 600px;
}
</style>

<style >
/* 选择框 */
.myselect {
  color: #fff;

  outline: none;
}
.myselect input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #fff;
}
.myselect input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #fff;
}
.myselect input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #fff;
}
.myselect input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #fff;
}
.myselect .el-input__inner {
  /*background-image: linear-gradient(to bottom, #b9aff2, #c29cf4);*/
  background: url("../assets/images/list/btn.png") no-repeat center top;
  background-size: 100% auto;
  height: 60px;
  line-height: 60px;
  border: none;
  color: #fff;
  font-size: 18px;
}
.myselect .el-input__inner:focus {
}
.myselect .el-input__suffix-inner .el-input__icon {
  color: #1f99b4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 12px;
  margin-top: -1px;
}

/* 公用弹窗 */
.com-dialog {
  text-align: left;
  background: none;
}
.el-dialog {
  background: none;
  border: none;
  box-shadow: none;
}
.el-dialog__wrapper {
  background: rgba(0, 0, 0, 0.5);
}
.dialog-course .el-dialog__header {
  display: none;
}
.el-dialog__header .el-dialog__title {
  font-family: newfont;
  color: #fff;
  font-size: 40px;
  text-shadow: 4px -1px 5px #e98ef7, -4px 1px 5px #e98ef7, 4px -1px 5px #e98ef7,
    -4px -1px 5px #e98ef7;
}

.el-dialog__body a {
  color: #444;
}
.el-dialog__body a:hover {
  color: slateblue;
}

.el-dialog__body .com-info-box .info {
  line-height: 25px;
  font-size: 16px;
}

.el-dialog__body .com-info-box .info .i-left {
  display: inline-block;
  width: 120px;
  text-align: justify;
  text-align-last: justify;
}

/* 分页按钮 */
.swiper-pagination-bullet-custom {
  width: 20px;
  height: 20px;
  border-radius: 100px;
  background: #fff;
  border: 7px solid #f041e8;
  outline: none;
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  color: #fff;
  background: #79c2d1;
}
.swiper-pagination-bullet-custom:hover {
  background: #79c2d1;
}

/* 关闭按钮 */
.btn-close {
  position: absolute;
  top: -60px;
  right: -35px;
  width: 50px;
}
.dialog-footer {
  text-align: center;
}
.dialog-footer img {
  display: inline-block;
  margin: 0 15px;
}
</style>
